module.exports = __webpack_public_path__ + "img/ANTENNA 5 PURPLE.091e022.svg";